import { render, staticRenderFns } from "./EnergyViewAdditionalFields.vue?vue&type=template&id=8ccc606c&scoped=true&"
import script from "./EnergyViewAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./EnergyViewAdditionalFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccc606c",
  null
  
)

export default component.exports